import { render } from "./my-network.vue?vue&type=template&id=496a3461&scoped=true"
import script from "./my-network.vue?vue&type=script&lang=js"
export * from "./my-network.vue?vue&type=script&lang=js"

import "@/css/bootstrap.min.css?vue&type=style&index=0&id=496a3461&scoped=true&lang=css"
import "./my-network.vue?vue&type=style&index=1&id=496a3461&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496a3461"]])

export default __exports__